import { render, staticRenderFns } from "./CompanyInfoView.vue?vue&type=template&id=5d0555e5&scoped=true"
import script from "./CompanyInfoView.vue?vue&type=script&lang=js"
export * from "./CompanyInfoView.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoView.vue?vue&type=style&index=0&id=5d0555e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0555e5",
  null
  
)

export default component.exports